import TR from 'utils/TR';
import { Chart } from 'chart.js';
import AbnormalCircle from 'components/common/AbnormalCircle';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import VBox from 'components/common/VBox';
import useRect from 'hooks/common/useRect';
import React from 'react';
import T from 'utils/T';
import { drawTextLines } from 'utils/draw';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';
import HalfDoughnutChart from '../../charts/HalfDoughnutChart';
import DoubleBarChart from 'components/charts/DoubleBarChart';
import Dot from 'components/common/Dot';

export default function InsulinBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    daily_avg_basic_injection_amt = 0,
    daily_avg_bolus_injection_amt = 0,
    injection_after_abnormal_bld_sugr_rate = 0,
    insulin_bf_day_avg_basic_amt = 0,
    insulin_bf_day_avg_bolus_amt = 0,
  } = data || {};

  const [currents, currents_min, currents_max] = React.useMemo(() => {
    return [
      [[{ label: 'base', value: daily_avg_basic_injection_amt }], [{ label: 'bolus', value: daily_avg_bolus_injection_amt }]],
      Math.min(daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt),
      Math.max(daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt)
    ];
  }, [daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt]);

  const [all, all_min, all_max] = React.useMemo(() => {
    return [
      [[
        { label: 'last_base', value: insulin_bf_day_avg_basic_amt },
        { label: 'last_bolus', value: insulin_bf_day_avg_bolus_amt }
      ], [
        { label: 'base', value: daily_avg_basic_injection_amt },
        { label: 'bolus', value: daily_avg_bolus_injection_amt }
      ]],
      Math.min(insulin_bf_day_avg_basic_amt, insulin_bf_day_avg_bolus_amt, daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt),
      Math.max(insulin_bf_day_avg_basic_amt, insulin_bf_day_avg_bolus_amt, daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt)
    ];
  }, [daily_avg_basic_injection_amt, daily_avg_bolus_injection_amt, insulin_bf_day_avg_basic_amt, insulin_bf_day_avg_bolus_amt]);

  // const max = React.useMemo(() => {
  //   return Math.max(...[
  //     66.05,
  //   ]);
  // }, []);

  return (
    <Segment {...ex(['OverviewBox', 'InsulinBox'], props)}>
      <HBox full>
        <VBox
          full
          {...ex('BoxContainer')}
        >
          <div>
            <div {...ex('BoxItem')}>
              {T('일평균 투여량')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              <div {...ex('BoxValue')}>
                {numberWithComma((daily_avg_basic_injection_amt + daily_avg_bolus_injection_amt).toFixed(1))}
              </div>
              <div {...ex('BoxUnit')}>
                {T('U')}
              </div>
            </HBox>
          </div>
          <div>
            <div {...ex('BoxItem')}>
              {T('볼루스후 이상혈당 발생')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              <div {...ex('BoxValue')}>
                {numberWithComma(injection_after_abnormal_bld_sugr_rate)}
              </div>
              <div {...ex('BoxUnit')}>
                {T('%')}
              </div>
            </HBox>
          </div>
        </VBox>
        <VBox full>
          <HBox {...ex('OverviewBoxLegends')}>
            <Dot {...{ color: '#1D82FF' }}>
              <div>
                {T('일평균 볼루스')}
              </div>
            </Dot>
            <Dot {...{ color: '#FF7D5E' }}>
              <div>
                {T('일평균 기저')}
              </div>
            </Dot>
            <Dot {...{ color: '#AAAAAA' }}>
              <div>
                {T('지난 기간')}
              </div>
            </Dot>
          </HBox>
          <HBox full>
            <VBox>
              <DoubleBarChart
                {...{
                  max: all_max,
                  min: currents_min * 0.9,
                  values: currents,
                  unit: T('U'),
                }}
              />
            </VBox>
            <VBox>
              <DoubleBarChart
                {...{
                  max: all_max,
                  min: all_min * 0.9,
                  values: all,
                  unit: T('U'),
                }}
              />
            </VBox>
          </HBox>
          <div {...ex('ChartLabel')}>
            {T('인슐린 투여량 (U)')}
          </div>
        </VBox>
      </HBox>
    </Segment >
  );
}
